import React from "react";
import Select from 'blocks/Select';
import { observer, inject } from "mobx-react";
import HttpClient from "services/HttpClient";

const ORGANIZATIONS = '/api/v1/organizations';

@observer
export default class OrganizationFilter extends React.Component {
  state = {
    organizations: [],
    organizationsData: [],
    selecetedOrganization: '',
  };

  componentDidMount() {
    new HttpClient().get(ORGANIZATIONS)
    .then(data => {
      if(data.status === 200) {
        const {body} = data;
        const organizationsData = body.organizations.map(organization => ({
          value: organization.id,
          title: organization.title,
        }));
        this.setState({
          organizations: body.organizations,
          organizationsData,
        });
      }
    });
  }

  handleChangeOrganization = e => {
    const {organizations} = this.state;
    const organization_id = +e.organizations;
    const organization = organizations.filter(organization => organization.id === organization_id)[0];
    this.setState({selecetedOrganization: organization.id});
    this.props.handleSubmit(`&workshop_types[]=4&organization_id=${organization.id}&page=1`);
  }

  render() {
    const {organizationsData, selecetedOrganization} = this.state;
    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <div className="workshop-creator-sidebar-user" style={{marginBottom: 0}}>
            <div className="workshop-creator-sidebar-user-avatar-holder">
              <Select
                divStyles={{margin: 0, padding: 0}}
                barStyles={{bottom: '3px'}}
                elements={organizationsData}
                placeholder="Organizations"
                label="Organizations"
                name="organizations"
                value={selecetedOrganization || []}
                handleChange={this.handleChangeOrganization}
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/OrganizationsFilter.jsx